import { ApexOptions } from "apexcharts";
import { ReactElement } from "react";
import { COLORS } from "../../../../constants/Colors";
import { MONTHS } from "../../../../constants/Months";
import { formatterDollarUSNoDecimal } from "../../../../utils/formatters";
import Chart from "react-apexcharts";
import { TVarianceTooltipItem, varianceTooltip } from "../../../../styles/apex-charts/ViziblyTooltips";
import { buildApexChartConfig } from "../../../../styles/apex-charts/ViziblyChartDefaultConfig";
import { TPlanDashChartData } from "../../data/logic/commonWidgetData";

interface IGLAccountGraphProps {
    chartData: TPlanDashChartData,
    months: string[]
}

export function GLAccountsGraph(props: IGLAccountGraphProps): ReactElement {
    const values: number[] = [];
    props.chartData.chartSeriesData.map(x => (
        values.push(...(x.values.filter(y => typeof y === "number") as number[]))
    ));

    const yMin = Math.min(...values) * .9;
    const yMax = Math.max(...values) * 1.1;

    const options: ApexOptions = {
        chart: {
            type: 'line',
            stacked: true,
        },
        legend: {
            show: true,
            horizontalAlign: 'left',
        },
        xaxis: {
            categories: props.months,
        },
        stroke: {
            show: true,
            colors: props.chartData.chartSeriesData.length == 3 ? ['transparent', COLORS.LAVENDER_400] : undefined,
            width: props.chartData.chartSeriesData.length == 3 ? 2 : undefined,
            dashArray: props.chartData.chartSeriesData.length == 3 ? [0, 3] : undefined
        },
        yaxis: {
            min: yMin,
            max: yMax,
            labels: {
                formatter: (val: number) => {
                    if (!val || val == 0) {
                        return '0';
                    }

                    return `${formatterDollarUSNoDecimal.format(val)}`;
                },
            },
        },
        tooltip: {
            custom: ({ dataPointIndex, w }) => {
                const tooltipTitle = w.globals.categoryLabels[dataPointIndex];
                const series: ApexAxisChartSeries = w.config.series;
                const itemOne: Partial<TVarianceTooltipItem> = {};
                const itemTwo: Partial<TVarianceTooltipItem> = {};

                series.forEach((seriesItem) => {
                    const value = seriesItem?.data[dataPointIndex] as (number | undefined);
                    const name = seriesItem?.name as (string | undefined);
                    const color = seriesItem?.color as (string | undefined);

                    if (value != null) {
                        if (itemOne.value == undefined) {
                            itemOne.label = name;
                            itemOne.value = value;
                            itemOne.color = color;
                        } else {
                            itemTwo.label = name;
                            itemTwo.value = value;
                            itemTwo.color = color;
                        }
                    }
                });

                return varianceTooltip(
                    tooltipTitle,
                    itemOne as TVarianceTooltipItem,
                    itemTwo as TVarianceTooltipItem,
                    props.chartData.varianceCounts[dataPointIndex],
                    'dollar',
                );
            },
            shared: true,
        }
    };

    const mappedApexSeries: ApexAxisChartSeries = props.chartData.chartSeriesData.map(x => ({
        name: x.name,
        color: x.color,
        type: x.type,
        data: x.values,
    }));

    const chartConfig = buildApexChartConfig({ options, series: mappedApexSeries });

    return (
        <Chart
            options={chartConfig.options}
            series={chartConfig.series}
            height={360}
        />
    );
}